var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage,"loader":_vm.type},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }